<template>
  <div class="row">
    <div class="col-12 mb-2" v-show="isFullPage">
      <strong>{{ $t("Statistic.filters.title") }}</strong>
    </div>
    <div class="col-md-4" v-if="isEntityFilter">
      <select-entity :entities="entities"
                     :labelEntity="$t('Offers.filters.entities')"
                     :entitySelector="'entity_id_in'"
                     :colLabel="'col-md-12'"
                     :colSelect="'col-md-12'"
                     :marginEntity="'m-t-0'"
                     :preselectedEntityId="filters_display.entity_id_in"
                     @entity-changed="changeFilterEntity" />
    </div>
    <div class="col-md-4 occupation-filter" v-show="isFullPage">
      <label for="replaced_occupation_id_in" class="control-label label-input-filter">
        {{ $t("Offers.filters.occupations") }}
      </label>
      <multiselect v-if="!isIE" v-model="filters_display.replaced_occupation_id_in"
                   id="replaced_occupation_id_in"
                   label="name"
                   track-by="id"
                   @input="addFilterId"
                   :placeholder="$t('multiselect.placeholder')"
                   :showLabels="false"
                   :multiple="true"
                   :options="occupationsOptions">
        <span slot="noResult">{{ $t('OfferForm.no_service') }}</span>
      </multiselect>
      <v-select v-else multiple v-model="occupationsSelectedIE"
                @input="addFilterOccupationIdIE"
                :placeholder="$t('multiselect.placeholder')"
                :options="occupationsOptionsIE">
      </v-select>
    </div>
    <div class="col-md-4 hub-filter" v-show="isFullPage" v-if="showFilterHub">
      <label for="hub_id_in" class="control-label label-input-filter">
        {{ $t("Offers.filters.hubs") }}
      </label>
      <multiselect v-if="!isIE" v-model="filters_display.hub_id_in"
                   id="hub_id_in"
                   label="name"
                   track-by="id"
                   @input="addFilterId"
                   :placeholder="!checkDisableSelect ? $t('multiselect.placeholder') : ''"
                   :showLabels="false"
                   :multiple="true"
                   :disabled="checkDisableSelect"
                   :options="hubsOptions">
        <span slot="noResult">{{ $t('OfferForm.no_occupation') }}</span>
      </multiselect>
      <v-select v-else multiple v-model="servicesSelectedIE"
                @input="addFilterHubIdIE"
                :placeholder="!checkDisableSelect ? $t('multiselect.placeholder') : ''"
                :disabled="checkDisableSelect"
                :options="hubsOptionsIE">
      </v-select>
    </div>
    <div class="col-md-4 service-filter" v-show="isFullPage">
      <label for="replaced_service_id_in" class="control-label label-input-filter">
        {{ $t("Offers.filters.services") }}
      </label>
      <multiselect v-if="!isIE" v-model="filters_display.replaced_service_id_in"
                   id="replaced_service_id_in"
                   label="name"
                   track-by="id"
                   @input="addFilterId"
                   :placeholder="!checkDisableSelect ? $t('multiselect.placeholder') : ''"
                   :showLabels="false"
                   :multiple="true"
                   :disabled="checkDisableSelect"
                   :options="servicesOptions"
                   :group-label="showFilterHub ? 'hub' : ''"
                   :group-values="showFilterHub ? 'services' : ''"
                   :group-select="false">
        <span slot="noResult">{{ $t('OfferForm.no_occupation') }}</span>
      </multiselect>
      <v-select v-else multiple v-model="servicesSelectedIE"
                @input="addFilterServiceIdIE"
                :placeholder="!checkDisableSelect ? $t('multiselect.placeholder') : ''"
                :disabled="checkDisableSelect"
                :options="servicesOptionsIE">
      </v-select>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import ie_mixin from '@/mixin/ie'
  import SelectEntity from '@/components/common/SelectEntity'
  import { checkRoleManager } from '@/helpers/roles'
  import { getUserWithEntities } from '@/backend/users'
  import _ from "lodash";

  export default {
    name: 'Filters',
    data() {
      return {
        entities: [],
        entityId: null,
        isSingleEntity: false,
        isExistsIndependent: false,
        currentUser: '',
        disableSelect: true
      }
    },
    mixins: [ie_mixin],
    components: { SelectEntity },
    computed: {
      ...mapGetters({
        hubsOptions: 'users/manageableHubs',
        manageableServices: 'users/manageableServices',
        occupationsOptions: 'users/manageableOccupations',
        isFullPage: 'stats/isFullPage',
        filters_display: 'stats/filters_display'
      }),
      isManager: function() {
        return checkRoleManager(this.currentUser.role)
      },
      isEntityFilter() {
        return this.isManager && !this.isSingleEntity
      },
      existsEntityIndependent() {
        return this.isEntityFilter && this.isExistsIndependent
      },
      isFullPage() {
        let seeFullPage = !this.existsEntityIndependent || (this.existsEntityIndependent && this.filters_display.entity_id_in)
        this.setFullPage(seeFullPage)
        return seeFullPage
      },
      checkDisableSelect() {
        return this.isEntityFilter && this.disableSelect
      },
      hasManyHubs() {
        return this.hubsOptions.length > 1
      },
      showFilterHub() {
        return  this.hasManyHubs && ( this.filters_display.entity_id_in !== null || this.entities.length === 1 )
      },
      servicesOptions() {
        if(!this.showFilterHub || this.isIE) {
          return this.manageableServices;
        }
        return this.buildServicesListGroupedByHubs();
      }
    },
    watch: {
      filters_display: {
        handler: function (old_filters, new_filters) {
          this.disableSelect = (new_filters.entity_id_in == null)
          this.setStateFilter(new_filters)
        },
        deep: true
      }
    },
    methods: {
      ...mapActions({
        setFullPage: 'stats/setFullPage',
        setEntity: 'stats/setEntity',
        setStateFilter: 'stats/setStateFilter'
      }),
      addFilterId: function (values, id) {
        let value = values.map((value) => value.id);
        let result = {id: id, value: value}
        this.$emit('change', result)
      },
      addFilterOccupationIdIE: function (values) {
        let selectedValues = [];
        for (let i = 0; i < values.length; i++) {
          selectedValues.push(this.searchInArray(values[i], this.occupationsOptions))
        }
        this.addFilterId(selectedValues, "replaced_occupation_id_in")
      },
      addFilterHubIdIE: function (values) {
        let selectedValues = [];
        for (let i = 0; i < values.length; i++) {
          selectedValues.push(this.searchInArray(values[i], this.hubsOptions))
        }
        this.addFilterId(selectedValues, "hub_id_in")
      },
      addFilterServiceIdIE: function (values) {
        let selectedValues = [];
        for (let i = 0; i < values.length; i++) {
          selectedValues.push(this.searchInArray(values[i], this.manageableServices))
        }
        this.addFilterId(selectedValues, "replaced_service_id_in")
      },
      setStateEntity(entities) {
        if (entities.length == 1) {
          this.isSingleEntity = true
        } else if (entities.length > 1) {
          let independentEntities = entities.filter((e) => e['independent'])
          if (independentEntities.length > 0) {
            this.isExistsIndependent = true
          }
        }
      },
      changeFilterEntity(value) {
        let value_id = null
        if (value) value_id = value.id

        this.filters_display.entity_id_in = value_id
        let entity = value && value_id ? value : null
        this.setEntity(entity)
        let result = { id: 'entity_id_in', value: value_id };
        this.disableSelect = (value_id == null)
        this.resetSelected()
        this.entityId = value.id
        this.$emit('change', result)
      },
      resetSelected: function() {
        this.filters_display.hub_id_in = ''
        this.filters_display.replaced_service_id_in = ''
        this.filters_display.replaced_occupation_id_in = ''
      },
      buildServicesListGroupedByHubs() {
        return this.hubsOptions.map(hub => {
          return {
            hub: hub.name,
            services: this.manageableServices.filter(service => service.hub_id == hub.id)
          };
        });
      },
      defineEntity() {
        let entity = null
        if (this.entities.length === 1) {
          entity = { id: this.entities[0].id }
        } else {
          entity = this.entities.find(e => e.id == this.$route.params.entity_id)
        }
        return entity
      }
    },
    mounted: function () {
      getUserWithEntities().then(res => {
        const user = res.data
        this.currentUser = res.data
        this.entities = user.entities
        this.setStateEntity(this.entities)
        if (!this.isSingleEntity && (!this.isExistsIndependent || user.role == 'corporation_admin')) {
          let entities = [{id: null, name: this.$i18n.t('models.resource_types.all')}]
          this.entities = entities.concat(user.entities)
        }
        let entity = this.defineEntity()
        this.changeFilterEntity(entity)
      })
    }
  }
</script>

<style type="text/scss">
  .label-input-filter {
    font-family: 'Montserrat';
    font-size: 10.5px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-weight: 500
  }

  .and {
    text-align: center;
  }

  .label-filter-date {
    padding-top: 8px;
  }

  .date-range-type {
    display: inline-flex;
  }

  .date-range-type .multiselect {
    color: #e51349
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/shared/Filters.vue